import React from 'react'
import PropTypes from 'prop-types'

class ScrollToError extends React.Component {
    componentDidUpdate (prevProps) {
        if (prevProps.submitCount !== this.props.submitCount && !this.props.isValid) {
            this.props.scrollToError()
        }
    }

    render () {
        return null
    }
}

PropTypes.propTypes = {
    formId: PropTypes.string.isRequired,
    submitCount: PropTypes.number.isRequired,
    isValid: PropTypes.number.isRequired,
    scrollToError: PropTypes.func.isRequired,
}

export default ScrollToError
